module.exports = __webpack_public_path__ + "img/ic_vin.9664ded0.svg";